import { PREMIUM_PLAN_NAME } from "./ProductUtils";

export const getPremiumPlanId = (subscriptionPlans) =>
  subscriptionPlans?.find((plan) => plan.name === PREMIUM_PLAN_NAME)?._id;
